export const freeLimits: string[][] = [
  ['30 days Storage'],
  ['Slack Only'],
  ['1,000 kb/s Reads', '17 kb/s Writes', 'Up to 10,000 Series'],
]

export const usageBasedLimits: string[][] = [
  ['Unlimited Storage Retention'],
  ['All Alert Handlers'],
  ['10,000 kb/s Reads', '1,000 kb/s Writes', 'Up to 1,000,000 Series'],
]

export const annualLimits: string[][] = [
  ['Unlimited Storage Retention'],
  ['All Alert Handlers'],
  ['Scale Reads As Needed', 'Scale Writes As Needed', 'Scale Series As Needed'],
]

export const annualUrl =
  'https://www.influxdata.com/contact-sales/?utm_campaign=cloud2.0&utm_medium=website&utm_source=contactsales'
